export default __webpack_public_path__ + "static/media/solution_03.462ac23b.png";